import { render, staticRenderFns } from "./Parametrizacao.vue?vue&type=template&id=fd6327f0&scoped=true"
import script from "./Parametrizacao.vue?vue&type=script&lang=js"
export * from "./Parametrizacao.vue?vue&type=script&lang=js"
import style0 from "./Parametrizacao.vue?vue&type=style&index=0&id=fd6327f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6327f0",
  null
  
)

export default component.exports